import { render, staticRenderFns } from "./passwordLost.vue?vue&type=template&id=4c2f447f&"
import script from "./passwordLost.vue?vue&type=script&lang=js&"
export * from "./passwordLost.vue?vue&type=script&lang=js&"
import style0 from "./passwordLost.vue?vue&type=style&index=0&id=4c2f447f&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports